import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 page-fill" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col flex-1 min-h-0 overflow-hidden"
}
const _hoisted_3 = {
  class: "row w-full mb-3 justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_4 = { class: "cardbody" }
const _hoisted_5 = { class: "flex flex-row-reverse items-center gap-3" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_8 = { class: "mt-5 table-section" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "title" }, "Findings", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: _normalizeClass(["flex", _ctx.tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton']),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
                }, [
                  (_ctx.tableRow.length == 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : (_openBlock(), _createElementBlock("img", _hoisted_7)),
                  _cache[1] || (_cache[1] = _createTextVNode(" Filters "))
                ], 2)
              ])
            ])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-xs mt-3" }, " Manage findings identified during compliance reviews. Record, track, and resolve gaps or issues to ensure timely remediation and continuous improvement of your organization’s security and compliance posture. ", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_tableData, {
              class: "flex-1 min-h-0",
              tableRowData: _ctx.tableRow,
              headersData: _ctx.headers,
              departmentArr: _ctx.deptOptions,
              locations: _ctx.locationObject,
              loadData: _ctx.dataLoading
            }, null, 8, ["tableRowData", "headersData", "departmentArr", "locations", "loadData"]),
            (_ctx.toolTipActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}